/**
 * Owner: Masa Bayu
 * File: shell-density.ts
 * Date:Time: 2026-09-15 20:04
 * Description: QXRead shell density contracts per §373 responsive band (mobile/tablet/desktop).
 */

import type { QxreadBreakpointBand } from '@qx/qxread-core';

export const QXREAD_SHELL_DENSITIES = ['compact', 'comfortable', 'roomy'] as const;
export type QxreadShellDensity = (typeof QXREAD_SHELL_DENSITIES)[number];

export interface QxreadShellLayoutContract {
  readonly band: QxreadBreakpointBand;
  readonly density: QxreadShellDensity;
  readonly navOrientation: 'wrap' | 'row';
  readonly brandScale: 'sm' | 'md' | 'lg';
  readonly columns: 1 | 2 | 3;
}

export function resolveQxreadShellLayout(band: QxreadBreakpointBand): QxreadShellLayoutContract {
  switch (band) {
    case 'mobile':
      return Object.freeze({
        band,
        density: 'compact',
        navOrientation: 'wrap',
        brandScale: 'sm',
        columns: 1,
      });
    case 'tablet':
      return Object.freeze({
        band,
        density: 'comfortable',
        navOrientation: 'wrap',
        brandScale: 'md',
        columns: 2,
      });
    case 'desktop':
      return Object.freeze({
        band,
        density: 'roomy',
        navOrientation: 'row',
        brandScale: 'lg',
        columns: 3,
      });
  }
}
